import get from 'lodash/get';

export default function hasNoBehavior(guideItem) {
  return !get(guideItem, 'behaviors.default.actionName');
}
